"use client";

import * as React from "react";

import { cn } from "@/src/lib/utils/cn";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          "inline-flex min-h-[3.25rem] w-full items-center justify-center gap-[0.65rem] px-6 py-[0.95rem] text-[0.96rem] font-bold text-white  [transition:all_220ms_ease] hover:enabled:-translate-y-[2px] hover:enabled:shadow-[0_22px_48px_rgba(238,49,106,0.34)] focus-visible:outline-none focus-visible:shadow-[0_0_0_4px_rgba(238,49,106,0.2),0_18px_40px_rgba(238,49,106,0.28)] disabled:cursor-not-allowed disabled:opacity-[0.78]",
          className,
        )}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
